<!-- eslint-disable -->
<template>
  <div class="container">
    <div class="row scta-box">
      <div class="col-lg-12">
        <center>
          <h1>特定商取引法に基づく表記</h1>
        </center>
        <div class="date">2025年9月17日 第一版</div>
        <div>
          <h2>事業者名</h2>
          <p>株式会社indent</p>
          <h2>代表者</h2>
          <p>釜形　勇気</p>
          <h2>所在地</h2>
          <p>〒101-0061　東京都千代田区神田三崎町3丁目6番12号神田三崎町ビル4階</p>
          <h2>お問い合わせ先</h2>
          <p>nola.cs@indent.co.jp</p>
          <p>※ 表示を省略している事項は、取引時に請求があれば遅滞なくご連絡します。</p>
          <h2>販売価格</h2>
          <p>
            商品ごとに異なります。各サービスの申込手続中に表示される価格（表示価格は消費税込みの価格です）をご確認ください。
          </p>
          <h2>商品代金以外に必要な料金</h2>
          <p>
            当サイトのページの閲覧、コンテンツ購入、ソフトウェアのダウンロード等に必要となるインターネット接続料金、通信料金は、お客様のご負担となります。
          </p>
          <h2>お支払い方法</h2>
          <p>Webサイトをご利用の場合</p>
          <ul>
            <li style="list-style-type: disc">クレジットカード決済</li>
          </ul>
          <p>スマホアプリをご利用の場合</p>
          <ul>
            <li style="list-style-type: disc">
              Apple Inc. や Google LLC 等、購入に係る決済を代行する会社が提供するお支払い方法
            </li>
          </ul>
          <h2>代金の支払時期</h2>
          <ol start="1">
            <li>
              <strong>Nolaプレミアム（サブスクリプション）</strong>
              <ul>
                <li style="list-style-type: disc">
                  申込時、および各更新日に課金されます。お客様が利用されている決済サービスの規約に従います。
                </li>
              </ul>
            </li>
          </ol>
          <ol start="2">
            <li>
              <strong>Fish（サービス内通貨）</strong>
              <ul>
                <li style="list-style-type: disc">購入手続き完了時に課金されます。</li>
              </ul>
            </li>
          </ol>
          <h2>役務の提供時期</h2>
          <ol start="1">
            <li>
              <strong>Nolaプレミアム（サブスクリプション）</strong>
              <ul>
                <li style="list-style-type: disc">お支払い手続き完了後、直ちにプレミアム機能をご利用いただけます。</li>
              </ul>
            </li>
          </ol>
          <ol start="2">
            <li>
              <strong>Fish（サービス内通貨）</strong>
              <ul>
                <li style="list-style-type: disc">お支払い手続き完了後、直ちにお客様のアカウントに付与されます。</li>
              </ul>
            </li>
          </ol>
          <h2>キャンセル・中途解約について</h2>
          <ol start="1">
            <li>
              <strong>Nolaプレミアム（サブスクリプション）</strong>
              <ul>
                <li style="list-style-type: disc">
                  いつでもサブスクリプションの解約手続きが可能です。解約手続きをされた場合、次回の更新は行われず、契約期間の満了をもってサービスの提供が終了します。
                </li>
                <li style="list-style-type: disc">
                  契約期間の途中で解約された場合でも、日割り計算による返金を含め、一切の返金はいたしかねますので、あらかじめご了承ください。
                </li>
              </ul>
            </li>
          </ol>
          <ol start="2">
            <li>
              <strong>Fish（サービス内通貨）</strong>
              <ul>
                <li style="list-style-type: disc">
                  ご購入手続き完了後は申し込みを撤回・解除することはできません。<br />あらかじめご了承ください。
                </li>
                <li style="list-style-type: none; text-indent: -1em">
                  ※
                  Fishを利用した機能が利用できなかったなどの不具合があった場合は、不具合発生から7日以内を目処に、本サイト・本アプリのお問い合わせよりご連絡ください。
                </li>
              </ul>
            </li>
          </ol>
          <h2>ソフトウェアの動作環境</h2>
          <p>
            Nolaをご利用いただくために必要な動作環境は「<a
              href="https://booming-buckthorn-e8b.notion.site/6ae1258a5e854528b7c0e7e8f2fdba30?source=copy_link"
              >Nolaヘルプページ</a
            >」をご確認ください。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  // NOTE: metaタグの設定
  metaInfo() {
    if (process.env.NODE_ENV === "production") {
      return {};
    }
    return {
      meta: [
        {
          name: "robots",
          content: "none",
        },
      ],
    };
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.scta-box {
  background-color: var(--color-surface-subtle);
  padding: 100px 13% 50px 13%;
  border: solid 10px var(--color-border);
}
.scta-box h1 {
  font-size: var(--font-size-xxl);
  font-weight: var(--font-weight-bold);
  margin-top: 0px;
  margin-bottom: 30px;
  color: var(--color-text-normal);
  text-align: center;
  position: relative;
  display: inline-block;
  padding: 0 55px;
}
.scta-box h1:before,
.scta-box h1:after {
  content: "";
  position: absolute;
  top: 50%;
  display: inline-block;
  width: 45px;
  height: 1px;
  background-color: var(--color-text-normal);
}
.scta-box h1:before {
  left: 0;
}
.scta-box h1:after {
  right: 0;
}

.scta-box h2 {
  font-size: var(--font-size-xl);
  margin-top: 30px;
  margin-bottom: 20px;
  color: var(--color-text-normal);
  border-bottom: solid 1px var(--color-border);
}
.scta-box p {
  color: var(--color-text-normal);
}
.scta-box ol {
  padding-inline-start: 1rem;
  color: var(--color-text-normal);
}
.scta-box ul {
  padding-inline-start: 2rem;
  color: var(--color-text-normal);
}
.scta-box a {
  color: var(--color-primary);
}
.date {
  text-align: right;
  font-size: var(--font-size-xs);
  color: var(--color-text-low);
}

/*スマホ画面でサイドメニューを非表示*/
@media screen and (max-width: 576px) {
  /* 表示領域が576px以下の場合に適用するスタイル */
  .scta-box {
    padding: 50px 15px;
  }
  .scta-box h1 {
    font-size: var(--font-size-xl);
    margin-bottom: 20px;
  }
  .scta-box h2 {
    font-size: var(--font-size-md);
    margin-top: 30px;
    margin-bottom: 15px;
  }
  .scta-box p {
    font-size: var(--font-size-sm);
  }
}
</style>
